"use strict";

var GridListToggleHelper = {
	gridListToggleClicked: function($element, componentName, gridWrapperClass, listWrapperClass) {
		var $resultsComponent = $element.closest(`[data-component='${componentName}']`);
		var $gridResults = $resultsComponent.find(`.${gridWrapperClass}`);
		var $listResults = $resultsComponent.find(`.${listWrapperClass}`);
		if (!$gridResults.length || !$listResults.length) {
			//There is only one, break out
			return;
		}

		if ($element.is("[data-component='gridListToggle.gridButton']")) {
			$gridResults.toggle(true);
			$listResults.toggle(false);
			$resultsComponent.find("[data-component='gridListToggle.gridButton']").addClass("resultsSelected");
			$resultsComponent.find("[data-component='gridListToggle.listButton']").removeClass("resultsSelected");
			$resultsComponent.attr("data-selected-results-view", "grid");
		} else {
			$gridResults.toggle(false);
			$listResults.toggle(true);
			$resultsComponent.find("[data-component='gridListToggle.gridButton']").removeClass("resultsSelected");
			$resultsComponent.find("[data-component='gridListToggle.listButton']").addClass("resultsSelected");
			$resultsComponent.attr("data-selected-results-view", "list");
		}
	},

	initializeGridListToggle: function(id, previouslySelectedView, componentName, gridWrapperClass, listWrapperClass) {
		//For every search results or category, we are making sure the first is visible and second is not.
		//	We are also setting the gridListToggle buttons the appropriate class.
		if (id) {
			id = `#${id}`;
		} else {
			id = "";
		}

		$(`${id}[data-component='${componentName}']`).each((index, element) => {
			var $resultsComponent = $(element);
			var $results = $resultsComponent.find(`.${gridWrapperClass},.${listWrapperClass}`).first();
			var $gridResults = $resultsComponent.find(`.${gridWrapperClass}`);
			var $listResults = $resultsComponent.find(`.${listWrapperClass}`);

			if (($gridResults.length && previouslySelectedView === "grid") || ($results.hasClass(gridWrapperClass) && (previouslySelectedView !== "list" || !$listResults.length))) {
				//Grid is first, so let's make it enabled
				$gridResults.toggle(true);
				$listResults.toggle(false);
				$resultsComponent.find("[data-component='gridListToggle.gridButton']").addClass("resultsSelected");
				$resultsComponent.find("[data-component='gridListToggle.listButton']").removeClass("resultsSelected");
			} else {
				//List is the first results, so let's make it enabled
				$gridResults.toggle(false);
				$listResults.toggle(true);
				$resultsComponent.find("[data-component='gridListToggle.gridButton']").removeClass("resultsSelected");
				$resultsComponent.find("[data-component='gridListToggle.listButton']").addClass("resultsSelected");
			}

			$(element).find("[data-component='gridListToggle.gridButton'],[data-component='gridListToggle.listButton']").click(event => {
				this.gridListToggleClicked($(event.currentTarget), componentName, gridWrapperClass, listWrapperClass);
			});
		});
	}
};

module.exports = GridListToggleHelper;
